export namespace UiKitNs {
  export enum RouteEnums {
    CSS_TOKENS = 'ui-kit-css-tokens',
    CSS_TOKENS_SCALE = 'ui-kit-css-tokens-scale',
    TYPOGRAPHY = 'ui-kit-typography',
    SCROLLBAR = 'ui-kit-scrollbar',
    ACCORDION = 'ui-kit-accordion',
    ALERT = 'ui-kit-alert',
    AVATAR = 'ui-kit-avatar',
    BADGE = 'ui-kit-badge',
    BREADCRUMB = 'ui-kit-breadcrumb',
    BUTTON = 'ui-kit-button',
    BUTTON_GROUP = 'ui-kit-button-group',
    CARD = 'ui-kit-card',
    CHECKBOX = 'ui-kit-checkbox',
    COMBOBOX = 'ui-kit-combobox',
    COMMAND = 'ui-kit-command',
    COMPOSER = 'ui-kit-composer',
    CONTEXT_MENU = 'ui-kit-context-menu',
    DIALOG = 'ui-kit-dialog',
    DROPDOWN_MENU = 'ui-kit-dropdown-menu',
    DROPZONE = 'ui-kit-dropzone',
    FIELD = 'ui-kit-field',
    INPUT = 'ui-kit-input',
    EDITABLE_HEADING = 'ui-kit-editable-heading',
    INPUT_GROUP = 'ui-kit-input-group',
    KBD = 'ui-kit-kbd',
    LOADING = 'ui-kit-loading',
    LOGO = 'ui-kit-logo',
    METER = 'ui-kit-meter',
    PAGINATION = 'ui-kit-pagination',
    POPOVER = 'ui-kit-popover',
    PULSE = 'ui-kit-pulse',
    OUTLINE_CARD = 'ui-kit-outline-card',
    CONTENT_CARD = 'ui-kit-content-card',
    CHAT_MESSAGE = 'ui-kit-chat-message',
    THINKING = 'ui-kit-thinking',
    QUESTIONNAIRE = 'ui-kit-questionnaire',
    RADIO_GROUP = 'ui-kit-radio-group',
    SELECT = 'ui-kit-select',
    SEPARATOR = 'ui-kit-separator',
    SIDEBAR_NAV = 'ui-kit-sidebar-nav',
    SKELETON = 'ui-kit-skeleton',
    SLIDER = 'ui-kit-slider',
    SPLITTER = 'ui-kit-splitter',
    SWATCH = 'ui-kit-swatch',
    SWITCH = 'ui-kit-switch',
    TABLE = 'ui-kit-table',
    TABLE_OF_CONTENTS = 'ui-kit-table-of-contents',
    TABS = 'ui-kit-tabs',
    TEXTAREA = 'ui-kit-textarea',
    TOAST = 'ui-kit-toast',
    TOGGLE = 'ui-kit-toggle',
    TOOLTIP = 'ui-kit-tooltip',
    TREE = 'ui-kit-tree',
    WORKSPACE_ITEM = 'ui-kit-workspace-item',

    // Views: whole screens assembled out of the components above.
    CHAT = 'ui-kit-chat',
    ESTIMATION = 'ui-kit-estimation',
    HEADER = 'ui-kit-header',
    IMPORT = 'ui-kit-import',
    MEMBERS = 'ui-kit-members',
    SCREENS = 'ui-kit-screens',
    SIDEBAR = 'ui-kit-sidebar',
  }

  export enum TokenLayer {
    PRIMITIVE = 'primitive',
    SEMANTIC = 'semantic',
    COMPONENTS = 'components',
  }

  export interface Token {
    name: string
    value: string
  }

  export interface TokenFile {
    layer: TokenLayer
    fileName: string
    tokens: Token[]
  }

  export interface TokenGroup {
    key: string
    title: string
    anchorId: string
    tokens: Token[]
  }

  export interface GroupedTokenFile {
    fileName: string
    groups: TokenGroup[]
  }
}
